import { render, staticRenderFns } from "./Inspections.vue?vue&type=template&id=148133e5&scoped=true&"
import script from "./Inspections.vue?vue&type=script&lang=js&"
export * from "./Inspections.vue?vue&type=script&lang=js&"
import style0 from "./Inspections.vue?vue&type=style&index=0&id=148133e5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148133e5",
  null
  
)

export default component.exports